module.exports = __webpack_public_path__ + "images/index/home.c73a2b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/school/home.jpg
// module id = 13mM
// module chunks = 21